import { X, AlertTriangle } from "lucide-react";

// Herbruikbare bevestigings-pop-up voor het Super Admin-portaal.
export default function ConfirmModal({ open, title, message, confirmLabel = "Bevestigen", cancelLabel = "Annuleren", danger = true, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[130] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onCancel} data-testid="sa-confirm-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-5" onClick={(e) => e.stopPropagation()}>
        <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-3 ${danger ? "bg-rose-50" : "bg-indigo-50"}`}>
          <AlertTriangle className={`w-6 h-6 ${danger ? "text-rose-600" : "text-indigo-600"}`} />
        </div>
        <p className="font-head font-black text-lg">{title}</p>
        {message && <p className="text-sm text-slate-500 mt-1">{message}</p>}
        <div className="flex gap-2 mt-5">
          <button data-testid="sa-confirm-cancel" onClick={onCancel} className="flex-1 rounded-xl border border-slate-200 py-2.5 font-bold text-sm hover:bg-slate-50">{cancelLabel}</button>
          <button data-testid="sa-confirm-ok" onClick={onConfirm}
            className={`flex-1 rounded-xl py-2.5 font-bold text-sm text-white ${danger ? "bg-rose-600 hover:bg-rose-700" : "bg-indigo-600 hover:bg-indigo-700"}`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
